/* @flow */
import Entity from 'lib/Entity';

export default class RecipientSummary extends Entity {
  initialize() {
    this.idAttribute = 'uuid';
  }

  getNotAttendingCount(): number {
    return this.get('not_attending_count');
  }

  getAttendingCount(): number {
    return this.get('attending_count');
  }

  getNotRespondingCount(): number {
    return this.get('not_responded_count');
  }

  getPaidCount(): number {
    return this.get('paid_count');
  }

  getInvitedCount(): number {
    return this.get('invited_count');
  }

  getMaybeCount(): number {
    return this.get('maybe_count');
  }

  getResponsesCount(): number {
    return (
      this.getAttendingCount() +
      this.getNotAttendingCount() +
      this.getMaybeCount()
    );
  }
}



// WEBPACK FOOTER //
// ./src/entities/RecipientSummary.js